import React from "react";
import { Card, CardHeader, CardContent, Typography, Box, Divider } from "@material-ui/core";
import LaunchIcon from "@material-ui/icons/Launch";

const currencyFmt = (v, code = "USD") =>
  new Intl.NumberFormat(undefined, { style: "currency", currency: code, maximumFractionDigits: 0 }).format(v || 0);

export default function LeaderboardList({
  title,
  rows = [],
  currency = "USD",
  money = true,
  onRowClick,
  maxRows = 20,
  scrollHeight = 320,
  headerAction = null,
}) {
  return (
    <Card variant="outlined" style={{ height: "100%" }}>
      <CardHeader title={title} action={headerAction} />
      <CardContent style={{ maxHeight: scrollHeight, overflowY: "auto" }}>
        {rows.length === 0 ? (
          <Typography color="textSecondary">No data.</Typography>
        ) : (
          rows.slice(0, maxRows).map((r, idx) => {
            const clickable = typeof onRowClick === "function";
            const handleClick = () => clickable && onRowClick(r);
            return (
              <Box
                key={idx}
                display="flex"
                alignItems="center"
                py={0.75}
                onClick={handleClick}
                style={{
                  cursor: clickable ? "pointer" : "default",
                  transition: "background 0.2s ease",
                }}
              >
                <Box style={{ minWidth: 0, paddingRight: 8 }}>
                  <Box display="flex" alignItems="center" justifyContent="space-between" style={{ gap: 4 }}>
                    <Typography variant="body2" style={{ fontWeight: 600 }} noWrap>
                      {r.left}
                    </Typography>
                    {clickable && (
                      <Box display="flex" alignItems="center" style={{ gap: 2 }}>
                        <Typography variant="caption" color="primary">
                          To Product
                        </Typography>
                        <LaunchIcon fontSize="small" color="primary" style={{ fontSize: 14 }} />
                      </Box>
                    )}
                  </Box>
                  {r.sub && (
                    <Typography variant="caption" color="textSecondary">
                      {r.sub}
                    </Typography>
                  )}
                </Box>
                <Box flexGrow={1} mx={1}>
                  <Divider />
                </Box>
                <Typography
                  variant="body2"
                  style={{ fontWeight: 600, textAlign: "right", whiteSpace: "nowrap", flexShrink: 0 }}
                >
                  {money ? currencyFmt(Number(r.right), currency) : r.right}
                </Typography>
              </Box>
            );
          })
        )}
      </CardContent>
    </Card>
  );
}
